import { reducer } from './reducer'
import * as rc from '@safefleet/react-common'

const vehicles = {
    ...rc.vehicles,
    reducer,
}
export default vehicles
